import { render, staticRenderFns } from "./GTitleBar.vue?vue&type=template&id=0af3a589&scoped=true&"
import script from "./GTitleBar.vue?vue&type=script&lang=ts&"
export * from "./GTitleBar.vue?vue&type=script&lang=ts&"
import style0 from "./GTitleBar.vue?vue&type=style&index=0&id=0af3a589&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af3a589",
  null
  
)

export default component.exports